import { EventEmitter, OnInit } from '@angular/core';
import { Listing } from '../../../../classes/listing';
import { SearchResult } from '../../search-bar.component';
import { ListingsService } from '../../../../services/listings.service';
var MlsResultComponent = /** @class */ (function () {
    function MlsResultComponent(listingService) {
        this.listingService = listingService;
        this.selectResult = new EventEmitter();
        this.favouriteClick = new EventEmitter();
        this.onBlur = new EventEmitter();
    }
    MlsResultComponent.prototype.ngOnInit = function () {
        this.setPriceOrPricePerSqFt();
    };
    MlsResultComponent.prototype.setPriceOrPricePerSqFt = function () {
        var _this = this;
        this.listingService.getPriceOrPricePerSqFtString(this.listing).subscribe(function (str) { return _this.priceOrPricePerSqFt = str; });
    };
    Object.defineProperty(MlsResultComponent.prototype, "listing", {
        get: function () {
            if (this.result.data instanceof Listing) {
                return this.result.data;
            }
            else {
                return new Listing(this.result.data);
            }
        },
        enumerable: true,
        configurable: true
    });
    MlsResultComponent.prototype.onFavouriteClick = function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        this.listing.isFavourite = !this.listing.isFavourite;
        this.favouriteClick.emit(this.listing);
    };
    return MlsResultComponent;
}());
export { MlsResultComponent };
